import { render, staticRenderFns } from "./Metadata.vue?vue&type=template&id=2518a74c&"
import script from "./Metadata.vue?vue&type=script&lang=js&"
export * from "./Metadata.vue?vue&type=script&lang=js&"
import style0 from "./Metadata.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports